import React from 'react';
import { Button } from '../ui/button';
import { Trash2, Download, Lock } from 'lucide-react';

const ConversationHistorySidebar = ({ language, conversations, onLoad, onDelete, onDownloadPdf, isPremium = true }) => (
  <div className="w-64 bg-white dark:bg-slate-800 border-r border-slate-200 dark:border-slate-700 overflow-y-auto">
    <div className="p-4">
      <h3 className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3">
        {language === 'es' ? 'Historial' : 'History'}
      </h3>
      <div className="space-y-2">
        {conversations.map((conv) => {
          const firstMessage = conv.messages.find((m) => m.role === 'user');
          const preview = firstMessage
            ? firstMessage.content.substring(0, 50) + '...'
            : 'Conversation';
          return (
            <div
              key={conv.conversation_id}
              className="group p-2 rounded hover:bg-slate-100 dark:hover:bg-slate-700 cursor-pointer flex items-start justify-between gap-1"
            >
              <div
                className="flex-1 text-sm text-slate-700 dark:text-slate-300"
                onClick={() => onLoad(conv.conversation_id)}
                data-testid={`lumera-conversation-${conv.conversation_id}`}
              >
                {preview}
              </div>
              <Button
                variant="ghost"
                size="sm"
                className="opacity-0 group-hover:opacity-100 p-1 h-auto"
                onClick={() => onDownloadPdf(conv.conversation_id)}
                title={language === 'es' ? 'Descargar PDF' : 'Download PDF'}
                data-testid={`lumera-download-pdf-${conv.conversation_id}`}
              >
                <Download className="w-3 h-3 text-purple-600" />
                {!isPremium && <Lock className="w-2.5 h-2.5 text-amber-600 ml-0.5" data-testid="lumera-sidebar-pdf-lock" />}
              </Button>
              <Button
                variant="ghost"
                size="sm"
                className="opacity-0 group-hover:opacity-100 p-1 h-auto"
                onClick={() => onDelete(conv.conversation_id)}
                data-testid={`lumera-delete-conversation-${conv.conversation_id}`}
              >
                <Trash2 className="w-3 h-3 text-red-500" />
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  </div>
);

export default ConversationHistorySidebar;
